import { Row } from 'react-bootstrap';
import Styles from './dashboardPage.module.scss';
import { Footer } from '../footer';
import { Navbar } from '../navbar';

const Dashboard = () => {
	return (
		<div>
			<Row>
				<Navbar/>
                <iframe class={Styles.Dashboard} rel='preload' title='Dashboard' src="https://public.tableau.com/views/Pakistan-Air-Quality-Dashboard/DATAANALYSISDASHBOARD?:showAppBanner=false&:showVizHome=no&:embed=true&:origin=viz_share_link" ></iframe>
				
				<Footer />
 			</Row>
 		</div>
);
};
export { Dashboard };
